import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  mainHeader: {
    fontSize: '2rem',
    fontWeight: '700',
    color: theme.palette.white.main,
    background: theme.palette.secondary.main,
  },

}));

export default useStyles;
